// extracted by mini-css-extract-plugin
module.exports = {"button__loading":"ButtonMakeOrder_button__loading__Cp_Fs"};